export enum ContentType {
  TEXT,
  VOICE,
  PHOTO,
  DOCUMENT,
  VIDEO,
  AUDIO,
}

export enum CommissionRateType {
  CO_PRODUCTION = 'CO_PRODUCTION',
  AFFILIATION = 'AFFILIATION',
  VIB_ROYALTIES = 'VIB_ROYALTIES',
}

export type GenericResponse = {
  success: boolean;
};
